import { AppState } from '@root/app-state.module';
import { createSelector } from '@ngrx/store';

export const selectWhatIsNew = (state: AppState) => state.whatIsNew;

export const selectAllAnnouncements = createSelector(
  selectWhatIsNew,
  (whatIsNewState) => whatIsNewState.allAnnouncements
);

export const selectAllEnabledAnnouncements = createSelector(
  selectWhatIsNew,
  (whatIsNewState) => whatIsNewState.allEnabledAnnouncements
);

export const selectAllReadAnnouncements = createSelector(
  selectWhatIsNew,
  (whatIsNewState) => whatIsNewState.allReadAnnouncements
);

export const selectAllUnreadAnnouncements = createSelector(
  selectWhatIsNew,
  (whatIsNewState) => whatIsNewState.allUnreadAnnouncements
);

export const selectAnnouncementsByContentId = createSelector(
  selectWhatIsNew,
  (whatIsNewState) => whatIsNewState.announcementsByContentId
);
